// No imports: the marketing site uses this too, so it must not pull app code into that bundle.

// The app sidebar's background. Keep it to a few feature panels so it stays a brand accent, not wallpaper.
export const BRAND_WASH = 'bg-gradient-to-br from-[#eaf2fd] via-[#f3f7fd] to-[#e3edfb]';
